import React, { useState } from 'react';
import {
  Stack,
  TextInput,
  Button,
  Group,
  Switch,
  Alert,
  Divider,
  Text
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { IconAlertCircle, IconStar } from '@tabler/icons-react';
import { curriculumService } from '../../services/curriculumService';

const CurriculumForm = ({ curriculum, mode, onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      title: curriculum?.title || '',
      is_default: curriculum?.is_default || false,
    },
    validate: {
      title: (value) => (!value ? 'Title is required' : null),
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (mode === 'create') {
        await curriculumService.createCurriculum(values);
        notifications.show({
          title: 'Success',
          message: 'Curriculum created successfully',
          color: 'green',
        });
      } else {
        await curriculumService.updateCurriculum(curriculum.id, values);
        notifications.show({
          title: 'Success',
          message: 'Curriculum updated successfully',
          color: 'green',
        });
      }
      onSubmit();
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to save curriculum';
      notifications.show({
        title: 'Error',
        message,
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        {mode === 'edit' && curriculum && (
          <Alert icon={<IconAlertCircle size="1rem" />} color="blue">
            Editing curriculum: {curriculum.title}
          </Alert>
        )}

        <TextInput
          label="Curriculum Title"
          placeholder="Enter curriculum title"
          required
          {...form.getInputProps('title')}
        />

        <Divider label="Settings" />

        <Switch
          label="Set as Default Curriculum"
          description="This curriculum will be automatically assigned to new batches"
          leftSection={<IconStar size={16} />}
          {...form.getInputProps('is_default', { type: 'checkbox' })}
        />

        {form.values.is_default && (
          <Alert color="yellow">
            <Text size="sm">
              Setting this as default will remove the default status from any other curriculum.
            </Text>
          </Alert>
        )}

        <Group justify="flex-end" mt="md">
          <Button variant="light" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            {mode === 'create' ? 'Create Curriculum' : 'Update Curriculum'}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};

export default CurriculumForm;